import { render } from "./user-refbooks.vue?vue&type=template&id=36e66af6"
import script from "./user-refbooks.vue?vue&type=script&setup=true&lang=js"
export * from "./user-refbooks.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/components/user-refbooks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36e66af6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36e66af6', __exports__)) {
    api.reload('36e66af6', __exports__)
  }
  
  module.hot.accept("./user-refbooks.vue?vue&type=template&id=36e66af6", () => {
    api.rerender('36e66af6', render)
  })

}


export default __exports__